// extracted by mini-css-extract-plugin
module.exports = {"speedDial":"DeviceGroupInfoActions_component_speedDial__VZ5Kw"};